import { css } from 'styled-components'
import { theme } from 'styles/theme'

export const track = css`
  box-sizing: border-box;
  border: none;
  width: 100%;
  height: var(--track-height);
  background: ${theme.colors.background};
`

export const fill = css`
  height: var(--track-height);
  background: transparent;
`

export const thumb = css`
  box-sizing: border-box;
  border: none;
  width: var(--thumb-size);
  height: var(--thumb-size);
  border: var(--thumb-border-width) solid ${theme.colors.background};
  border-radius: 50%;
  background: var(--accent)
    url("data:image/svg+xml,%3Csvg width='29' height='30' viewBox='0 0 29 30' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.6624 15.2586L10.5859 11.3438L11.7014 12.4585L8.90282 15.2586L11.7014 18.0571L10.5819 19.1773L6.6624 15.2586ZM17.2984 12.4585L18.4187 11.3398L22.3374 15.2586L18.4147 19.1726L17.3 18.0579L20.0978 15.2586L17.2992 12.4593L17.2984 12.4585Z' fill='%23FFEDF4'/%3E%3C/svg%3E%0A")
    center center no-repeat;
`
